'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlEnterPress', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.bind("keypress", function (event) {
        if (event.which === 13) {
          $scope.$apply(function () {
            $scope.$eval($attrs.tlEnterPress);
          });
          event.preventDefault();
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlEnterPress.js
// module id = 2900
// module chunks = 13